import { Component, inject, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideIconComponent } from '../../lucide-icon/lucide-icon.component';
import { NavigationService } from '../../../../core/services/navigation.service';
import { ButtonComponent } from '../../button/button.component';

@Component({
  selector: 'app-mobile-nav-menu',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    RouterLinkActive,
    LucideIconComponent,
    ButtonComponent,
  ],
  templateUrl: './mobile-nav-menu.component.html',
  styleUrl: './mobile-nav-menu.component.css',
})
export class MobileNavMenuComponent {
  navService = inject(NavigationService);
  isOpen = input.required<boolean>();
  closed = output<void>();

  onClose(): void {
    this.closed.emit();
  }
}
